import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import {
    HandleStripePaymentRequestType,
    HandleStripePaymentResponseType
} from "@CheckOrder/api/types/HandleStripePaymentQuery.type";
import {
    setCheckOrderFatalError, setCheckOrderUserMessages,
    setPassengerDataUpdating,
    setStripeClientSecret
} from "@CheckOrder/reducers/checkOrderSlice";
import {setError} from "@Reducers/pageSlice";

export default function handleStripePaymentQuery(): OnQueryStartedFunctionAttrType<HandleStripePaymentRequestType, HandleStripePaymentResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        try {
            const response = await queryFulfilled

            if (response.meta.response.ok) {
                if (response.data.status === 'success') {
                    dispatch(setStripeClientSecret(response.data.clientSecret));
                }
            }
        } catch (err) {
            dispatch(setCheckOrderFatalError(true));
            dispatch(setPassengerDataUpdating(false))

            dispatch(setCheckOrderUserMessages([{
                error: err.error.data?.error[0],
                additionalData: err?.error.data?.additionalInfo,
            }]))
            dispatch(setError({
                error: 'check order submission failed',
                info: `data: ${JSON.stringify(request)}`,
            }))
        }
    }
}